import React from "react";
import wadeIcon from "../../../components/Icons/wadeIcon.svg";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { getEnable2FAQRCode } from "../../../services/Enable2FA.service";
import QRCode from "qrcode.react";

const MicrosoftAuthentication = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [qrvalue, setQrValue] = React.useState("");

  const onGetCodeButtonClickHandler = () => {
    navigate("/codeVerification", {
      state: {
        email: location.state.email,
        password: location.state.password,
        user_id: location.state.user_id,
        verifyType: "microsoft",
      },
    });
  };

  React.useEffect(() => {
    getEnable2FAQRCode(
      4,
      location?.state?.email || "",
      location?.state?.password || ""
    ).then((res: any) => setQrValue(res.provisioning_uri));
  }, []);

  return (
    <div className="tw-min-h-screen tw-bg-gray-100 tw-flex tw-justify-center tw-items-center tw-p-4">
      <div className="tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden tw-flex tw-flex-col tw-relative tw-w-full tw-max-w-xl">
        {/* Top Accent Line */}
        <div className="tw-h-2 tw-bg-gradient-to-r tw-from-[#03234a] tw-to-[#04346c] tw-w-full"></div>

        <div className="tw-p-6 md:tw-p-10 tw-flex tw-flex-col tw-items-center">
          {/* Logo */}
          <div className="tw-mb-8 tw-bg-gray-50 tw-p-4 tw-rounded-full tw-shadow-sm">
            <img src={wadeIcon} alt="WADE Logo" className="tw-h-8" />
          </div>

          {/* Title / Instruction */}
          <h2 className="tw-text-[#03234a] tw-text-2xl tw-font-bold tw-mb-6 tw-text-center">
            Scan the QR code
          </h2>

          {/* QR Code */}
          <div className="tw-mb-8 tw-p-4 tw-bg-white tw-rounded-xl tw-border-2 tw-border-gray-100 tw-shadow-inner">
            <QRCode value={qrvalue} size={180} />
          </div>

          {/* Action Button */}
          <Button
            className="tw-w-full tw-max-w-sm tw-h-12 tw-bg-[#03234a] tw-text-white tw-font-bold tw-tracking-wide tw-rounded-xl hover:tw-bg-[#052d5e] focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-[#03234a] disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-all tw-shadow-lg hover:tw-shadow-xl hover:-tw-translate-y-0.5 active:tw-translate-y-0"
            onClick={onGetCodeButtonClickHandler}
          >
            Ok, done!
          </Button>
        </div>
      </div>
    </div>
  );
};
export default MicrosoftAuthentication;
